import { googleAnalytics, mixpanel } from '@/core';

export const suggestAppLink = 'https://ideas.ringcentral.com/ideas/new';

export const trackSuggestApp = () => {
  googleAnalytics.trackPageView('Suggest an app');
  mixpanel.trackPageView('Suggest an app');
};
